/**
 * Menu item configurations for desktop and mobile
 */
import {
  PATH_HOME,
  PATH_EMPLOYEE,
  PATH_APPLICANTS,
  PATH_TRAINING_COURSES,
  PATH_TRAINING_PARTICIPANTS,
  PATH_TRAINING_CERTIFICATIONS,
  PATH_TRAINING_SUMMARY,
  PATH_TRAINING_MASS_UPDATE,
} from "../utils/routeConstants";
const menuSettings = [
  {
    label: "Home",
    tooltip: "Home",
    link: PATH_HOME,
    icon: "home",
    alwaysVisible: true,
  },
  {
    label: "Applicants",
    tooltip: "Applicants",
    link: PATH_APPLICANTS,
    icon: "user-friends",
    permission: { area: "modules", key: "Applicants" },
  },
  {
    label: "Employees",
    tooltip: "Employees",
    link: PATH_EMPLOYEE,
    icon: "users",
    permission: { area: "modules", key: "Employees" },
  },
  {
    label: "Training",
    tooltip: "Training",
    link: PATH_TRAINING_COURSES,
    icon: "user-graduate",
    permission: { area: "modules", key: "Training" },
    subMenu: [
      {
        label: "Courses",
        tooltip: "Courses",
        link: PATH_TRAINING_COURSES,
        permission: { area: "training", key: "Courses" },
      },
      {
        label: "Training Records",
        tooltip: "Training Records",
        link: PATH_TRAINING_PARTICIPANTS,
        permission: { area: "training", key: "Participants" },
      },
      {
        label: "Certifications",
        tooltip: "Certifications",
        link: PATH_TRAINING_CERTIFICATIONS,
        permission: { area: "training", key: "Certifications" },
      },
      {
        label: "Mass Update Training Records",
        tooltip: "Mass Update Training Records",
        link: PATH_TRAINING_MASS_UPDATE,
        permission: { area: "training", key: "Mass Update" },
      },
      {
        label: "Training Summary",
        tooltip: "Training Summary",
        link: PATH_TRAINING_SUMMARY,
        permission: { area: "training", key: "Summary" },
      },
    ],
  },
];

export default menuSettings;
